<template>
    <div class="modal-itemAdd">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">体检项目添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="体检时间" required prop="testTime">
                                    <el-date-picker
                                        ref="picker"
                                        v-model="addForm.testTime"
                                        type="date"
                                        placeholder="请选择体检时间"
                                        value-format="yyyy-MM-dd"
                                        :clearable='false'
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                            <el-card class="box-card" shadow='never' :body-style='{padding:0}'>
                                <div slot="header" class="clearfix">
                                    <span>体检项目</span>
                                    <el-button style="float: right;transform: translate(0px, -9px);" type="primary" @click="showModal">添加</el-button>
                                </div>
                                <el-table
                                    :data="itemInfo"
                                    style="width: 100%" border>
                                    <el-table-column
                                        prop="inspectionItemName"
                                        label="项目名称">
                                    </el-table-column>
                                    <el-table-column
                                        prop="remarks"
                                        label="项目检查结果">
                                    </el-table-column>
                                    <el-table-column fixed="right" label="操作" width="120">
                                        <template slot-scope="scope">
                                            <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index, itemInfo)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>
                            </el-col>
                            <el-col :span="18" class="item" style="padding-top:20px">
                                <el-form-item label="体检结果总建议" required prop="remarks">
                                    <el-input type="textarea" rows="3" placeholder="请输入体检结果总建议" v-model="addForm.remarks"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
        <GetItem  ref="myGetItem" v-show="showModalGetItem" v-bind:itemInfo="itemInfo" v-on:closeGetItem="showModalGetItem=false" v-on:getItemList="getItemList"></GetItem>
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {getStaffCode} from "@/utils/auth";
    import {hex_md5} from "@/common/Base64MD5";
    import GetItem from "./GetItem"
    export default {
        name: "Add",
        props:['inspectionItemList'],
        data() {
            return {
                loading: false,
                showModalGetItem: false,
                itemInfo:[],
                imageUrl:"",
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    testTime:'',
                    remarks:'',
                    itemArr:[],
                },
                rules:{
                    testTime:[
                        { required: true, message: '请选择体检时间', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入体检结果总建议', trigger: 'blur' },
                    ],
                }
            }
        },
        components:{
            GetItem
        },
        methods: {
            init(row){
                this.$refs.addForm.resetFields();
                this.itemInfo=[]
                this.addForm.elderlyCode=row.elderlyCode
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            handelIncrease(step) {
                this.addForm.detail=step
            },
            deleteRow(index, rows){
                rows.splice(index, 1);
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            showModal(){
                this.$refs.myGetItem.init()
                this.showModalGetItem=true
            },
            getItemList(row){
                console.log(row)
                this.itemInfo.push(row)
            },
            addSubmit(){
                this.loading = true;
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.itemArr=this.itemInfo
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"TestRecord/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }
</script>

<style  lang="scss" scoped>
    .modal-itemAdd {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
    .modal {
        background-color: #fff;
        box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 800px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .box-card /deep/ .box-card{
        padding: 0;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
        overflow-y:auto ;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>